import { LevelType } from '../Elements/GameState/Managers/GameEnums';

G.BoardActionManager = function(board) {

	this.board = board;

  this.onActionQueueEmpty = new Phaser.Signal();

	this.state = game.state.getCurrentState();

	this.actionList = [];

	this.noAction = true;

  this.madeMove = false;
  G.sb("madeMove").add(function() {
    this.madeMove = true;
  }, this);

	this.availableActions = {
		'move' : G.ActionMove,
		'processMatch' : G.ActionProcessMatch,
		'processFall' : G.ActionProcessFall,
		'boosterMatch' : G.ActionBoosterMatch,
		'boosterSwap' : G.ActionBoosterSwap,
		'shuffle' : G.ActionShuffle,
		'startBoosterInit' : G.ActionStartBoosters,
	};

	G.sb("onBoosterSelect").add(function(boosterData) {
		const nr = boosterData.boosterNr;
		if (nr == 1) {
			this.newAction('boosterSwap', boosterData);
		}	else {
			this.newAction('boosterMatch',boosterData);
		}
	},this);

	G.sb("onBoosterDeselect").add(function(){

		if (this.actionList.length == 1) {
			this.actionList[0].finish();
		}

	},this);

	this.noActionFrames = 0;

	this.shakingCandies = [];

};

G.BoardActionManager.prototype.update = function() {

	if (this.actionList.length == 0) {
		this.noAction = true;
		this.noActionFrames++;
		if (this.noActionFrames > 160 && G.saveState.data.allowHints) {
			this.noActionFrames = 0;
			this.glowPossibleMoves();
		}
		this.updateShakes();
	}else {
		this.noActionFrames = 0;
		this.noAction = false;
		this.actionList[0].update();
	}
};

G.BoardActionManager.prototype.normalCandies = ['0','1','2','3','4','5','6'];

G.BoardActionManager.prototype.updateShakes = function() {

	for (var i = this.shakingCandies.length; i--; ) {

		var shakeObj = this.shakingCandies[i];
		var candy = shakeObj.candy;

		shakeObj.dt += 0.04;

		candy.x = shakeObj.orgX + Math.sin(shakeObj.dt * (Math.PI*4))*shakeObj.wave;

		if (shakeObj.dt >= 1) {
			candy.x = shakeObj.orgX;
			candy.y = shakeObj.orgY;
			this.shakingCandies.pop();
		}

	}

};

G.BoardActionManager.prototype.breakShakes = function() {

	this.shakingCandies.forEach(function(shakeObj) {
		shakeObj.candy.x = shakeObj.orgX;
		shakeObj.candy.y = shakeObj.orgY;
	});

	this.shakingCandies = [];


};

G.BoardActionManager.prototype.glowPossibleMoves = function() {

	if (G.tutorialOpened) return;

	var possibleMoves = this.board.matcher.checkPossibleMoves();
	Phaser.ArrayUtils.shuffle(possibleMoves);

	if (possibleMoves.length == 0) return;

	var moveToShow = possibleMoves[0];

	this.shakeCandy(this.board.getCandy(moveToShow[0],moveToShow[1]));
	this.shakeCandy(this.board.getCandy(moveToShow[2],moveToShow[3]));

};

G.BoardActionManager.prototype.shakeCandy = function(candy) {

	this.shakingCandies.push({
		candy: candy,
		orgX: candy.x,
		orgY: candy.y,
		dt: 0,
		wave: G.l(5)
	});

};

G.BoardActionManager.prototype.newAction = function(type) {

	this.breakShakes();

	var args = [].slice.call(arguments,1);  

	this.actionList.push(new this.availableActions[type](this.board,this,args));

};

G.BoardActionManager.prototype.removeAction = function(action) {

	var index = this.actionList.indexOf(action);
	if (index != -1) {
		this.actionList.splice(index,1)
	}else {
		this.actionList.splice(0,1)
	}


	//no more
	if (this.actionList.length == 0)  {

		G.lvl.endCombo();

		
		if (G.lvl.goalAchieved) {

			if (G.lvl.moves > 0) {



				var normals = this.board.boardCandies.getNormalCandies();
				Phaser.ArrayUtils.shuffle(normals);


				var len = Math.min(G.lvl.moves,normals.length,15);

				for (var i = 0; i < len; i++) {

					var candy = normals[i];
					candy.changeInto(Math.random() < 0.5 ? 'horizontal' : 'vertical'); 
					candy.activatedByMove = true;
					G.lvl.changePointsNumber(G.json.settings.pointsForMoveLeft);
					var pxOut = G.lvl.board.cellToPxOut([candy.cellX,candy.cellY]);
					G.sb("displayPoints").dispatch(pxOut[0],pxOut[1],G.json.settings.pointsForMoveLeft);
					G.lvl.madeMove();
					this.board.checkSpecialMatchList.push(candy);

				}


				/*
				
				for (var i = 0; i < 5; i++) {

					if (G.lvl.moves == 0) break;

					var candy = this.board.boardCandies.getRandomNormal();
					if (candy) {
						candy.changeInto(Math.random() < 0.5 ? 'horizontal' : 'vertical'); 
						candy.activatedByMove = true;
						G.lvl.changePointsNumber(G.json.settings.pointsForMoveLeft);
						var pxOut = G.lvl.board.cellToPxOut([candy.cellX,candy.cellY]);
						G.sb("displayPoints.dispatch(pxOut[0],pxOut[1],G.json.settings.pointsForMoveLeft);
						
						G.lvl.madeMove();
						this.board.checkSpecialMatchList.push(candy);
					}
				}
				*/

				G.sfx.booster.play();
				game.time.events.add(800,function() {
					this.newAction('processMatch');
				},this);

				return;

			}else {

				var specialCandies = this.board.boardCandies.getAllSpecialCandies();
				if (specialCandies.length > 0) {
					specialCandies.forEach(function(candy) {
						candy.activatedByMove = true;
						this.board.checkSpecialMatchList.push(candy);
					},this);

					if (G.IMMEDIATE) {
						this.newAction('processMatch');
					}else {
						game.time.events.add(G.IMMEDIATE ? 1 : 300,function() {
							this.newAction('processMatch');
						},this);
					}
					
				}else {
						if (this.state.mode == LevelType.CHALLENGE) {
							if (!G.saveState.data.dailyBeaten) G.saveState.data.dailyBeaten = 0;
							G.saveState.data.dailyBeaten++;
						}
						
						return this.board.deconstruct();
				}	
			
			}
		}


		this.board.possibleMoves = this.possibleMoves = this.board.matcher.checkPossibleMoves()
		if (this.possibleMoves.length == 0) {
			return this.newAction('shuffle');
		}


    this.onActionQueueEmpty.dispatch();
		

		G.sb("actionQueueEmpty").dispatch();
    if (this.madeMove) {
      this.madeMove = false;
      G.sb("actionQueueEmptyAfterMove").dispatch();
    }
	}

};